import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/authentitcation/auth.service';
import { map } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.authenticate().pipe(
    map((authenticated) => {
      if (authenticated) {
        return true;
      } else {
        return router.createUrlTree(['/login']);
      }
    })
  );
};
